//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.SessionPreferences.js";
let d=[[[0,"CagePolylineColor",1,1],[0,"CagePolylineStyle",1,1],[0,"CagePolylineVertexColor",1,1],[0,"CagePolylineVertexSize",1,1],[0,"CagePolylineVertexStyle",1,1],[0,"CagePolylineWidth",1,1],[0,"CanAllowBackSideSelection",1,1],[0,"CanRefineMesh",1,0],[0,"ConstraintColor",1,1],[0,"HighlightFaceTranslucency",1,1],[0,"IsXRayCage",1,1],[0,"LineColor",1,1],[0,"LineStyle",1,1],[0,"LineWidth",1,1],[0,"RefinementRatio",1,0],[0,"VertexColor",1,1],[0,"VertexSize",1,1],[0,"VertexStyle",1,1]],[],[]];
SPLM.Preferences.MorphMeshPreferences = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.MorphMeshPreferences";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.MorphMeshPreferences.VertexStyleTypes = Object.freeze({
    "Square" : "Square", "Triangle" : "Triangle", "Circle" : "Circle", "Plus" : "Plus", "Cross" : "Cross"});

SPLM.Preferences.MorphMeshPreferences.VertexSizeTypes = Object.freeze({
    "Small" : "Small", "Medium" : "Medium", "Large" : "Large"});

SPLM.Preferences.MorphMeshPreferences.CagePolylineVertexStyles = Object.freeze({
    "None" : "None", "Square" : "Square", "Triangle" : "Triangle", "Circle" : "Circle", "Plus" : "Plus", "Cross" : "Cross"});

SPLM.Preferences.MorphMeshPreferences.CagePolylineVertexSizes = Object.freeze({
    "Small" : "Small", "Medium" : "Medium", "Large" : "Large"});

export default SPLM;